export const jobTitles = [
  {
    label: 'Merchant',
    value: 0,
  },
  {
    label: 'Marketing & Design Agency',
    value: 1,
  },
];
export const companySize = [
  {
    label: 'Just me',
    value: 0,
  },
  {
    label: '2-5 people',
    value: 1,
  },
  {
    label: '6-10 people',
    value: 2,
  },
  {
    label: '11+ people',
    value: 3,
  },
];

export const channelViaList = [
  {
    label: 'Shopify',
    value: 0,
  },
  {
    label: 'Podcast',
    value: 1,
  },
  {
    label: 'Friend',
    value: 2,
  },
  {
    label: 'Facebook',
    value: 3,
  },
  {
    label: 'Blogs',
    value: 4,
  },
  {
    label: 'Other sources',
    value: 5,
  },
];

export const objectivesList = [
  {
    label: 'Increase purchase frequency',
    value: 0,
    segments: ['Active loyals', 'Loyals', 'High spenders'],
  },
  {
    label: 'Prevent churn',
    value: 1,
    segments: ['At risk loyals', 'At risk repeats', 'At risk one timers'],
  },
  {
    label: 'Increase loyal customer purchases',
    value: 2,
    segments: ['Active loyals', 'Loyals', 'At risk loyals'],
  },
  {
    label: 'Improve product sales',
    value: 3,
    segments: ['Active one timers', 'Active new signups', 'Most likely to buy'],
  },
  {
    label: 'Increase new customer purchases',
    value: 4,
    segments: [
      'Active new signups',
      'At risk new signups',
      'Active one timers',
    ],
  },
  {
    label: 'Increase AOV',
    value: 5,
    segments: ['Customers (1+)', 'At risk repeats', 'Active repeats'],
  },
  {
    label: 'Increase customers LTV',
    value: 6,
    segments: ['One timers', 'Low value', 'Active new signups'],
  },
  {
    label: 'Increase repeat purchases',
    value: 7,
    segments: ['At risk repeats', 'Active repeats', 'Most likely to buy'],
  },
];

export const description: Record<string, string> = {
  'Churned loyals': 'Customers with 3+ purchases and who have churned.',
  Loyals: 'Customers with 3 or more purchases.',
  'Active loyals':
    'Customers with 3+ purchases and who are in the period most likely to convert again',
  'At risk loyals':
    'Customers with 3+ purchases and who are at risk of churning.',
  'Prevent High Value churn':
    'High Value customers who are at risk of churning. Maximize efforts on retention.',
  'At risk high value': 'High value customers who are at risk of churning.',
  'Active repeats':
    'Customers with 2 purchases and who are in the period most likely to convert again',
  'Most likely to buy':
    'Customers who are most likely to purchase based on recency.',
  'Reward top spenders':
    'Treat them like your family and keep them close. Build loyalty with rewards and spending tiers to increase revenue per user. They are also more likely to buy high ticket items.',
  'High spenders': 'Customers in the top quartile of order value',
  'Win-back High Value':
    'High Value customers who have likely churned. Add to win-back campaigns and re-target.',
  'Churned high value': 'High value customers who have likely churned.',
  'Active one timers':
    'Customers with 1 purchase and who are in the period most likely to convert again',
  Repeats: 'Customers with two purchases.',
  'Churned repeats': 'Customers with 2 purchases and who have churned.',
  'At risk repeats':
    'Customers with 2 purchases and who are at risk of churning.',
  'Most likely to churn': 'Customers who are at risk of churning.',
  'At risk one timers':
    'Customers with 1 purchase and who are at risk of churning.',
  'Used any discount':
    'Customers who have used a discount code with an order. Discount codes "Any"',
  'At risk new signups':
    "New signups who haven't purchased and are at risk of churning.",
  'Upsell low spenders':
    'Target these low spending customers with bundle offers and free shipping after $X to increase order value.',
  'Low spenders': 'Customers in the bottom quartile of order value',
  'Customers (1+)': 'All users with 1+ orders',
  'Full price':
    'Customers who have paid full price on every order. Discount codes exclude "Any"',
  'One timers': 'Customers with one purchase.',
  'Churned one timers': 'Customers with 1 purchase and who have churned.',
  Retail: 'Customer tags excluding "wholesale", "Wholesale"',
  'Win-back customers':
    'Customers who have likely churned. Send to win-back series flow and start retargeting them.',
  'Churned customers':
    'Customers who have not purchased for more than 2x the average days between purchases for their buyer segment',
  Signups: "All signups who haven't purchased anything.",
  'Churned signups': "Signups who haven't purchased and have churned.",
  'Low value':
    'Low value customers who have never purchased or are unlikely to purchase.',
  'Suppress Low Value':
    'Low value customers who have never purchased or are unlikely to purchase. Suppress or remove them from your lists.',
  'Accepts markeing true and false': '',
  Wholesale: 'Customer tags "wholesale", "Wholesale"',
  'Active subscribers':
    'Customer tags "active_subscriber", "Active Subscriber";',
  'Active new signups':
    "New signups who haven't purchased and are still likely to convert.",
  'Convert new signups':
    "New signups who haven't purchased and still likely to convert. Show recently browsed and top items to remind them to purchase with a small promotion.",
  'Increase purchase frequency':
    'Customers who are good candidates for increasing purchase frequency',
};

export interface Provider {
  name: string;
  description: string;
  recomended: boolean;
  category: string;
  auto_sync: boolean;
  connected: boolean;
}
export const initialProvidersState: Provider[] = [
  {
    name: 'Facebook',
    description: 'Create custom audiences in Facebook Ads',
    recomended: true,
    category: 'ads',
    auto_sync: false,
    connected: false,
  },
  {
    name: 'Google',
    description: 'Create customer match lists in Google Ads',
    recomended: true,
    category: 'ads',
    auto_sync: false,
    connected: false,
  },
  {
    name: 'Klaviyo',
    description: 'Create contact lists in Klaviyo',
    recomended: true,
    category: 'email',
    auto_sync: false,
    connected: false,
  },
  {
    name: 'MailChimp',
    description: 'Create contact lists with user tags in Mailchimp',
    recomended: false,
    category: 'email',
    auto_sync: false,
    connected: false,
  },
  {
    name: 'ActiveCampaign',
    description: 'Create contact lists in ActiveCampaign',
    recomended: false,
    category: 'email',
    auto_sync: false,
    connected: false,
  },
  {
    name: 'Drip',
    description: 'Create contact lists in Drip',
    recomended: false,
    category: 'email',
    auto_sync: false,
    connected: false,
  },
  {
    name: 'Omnisend',
    description: 'Create contacts with segment tags in Omnisend',
    recomended: false,
    category: 'email',
    auto_sync: false,
    connected: false,
  },
  {
    name: 'Postscript',
    description: 'Create the subscriber in Postscript',
    recomended: true,
    category: 'sms',
    auto_sync: false,
    connected: false,
  },
];
